module.exports = __webpack_public_path__ + "img/bank-06-citi.dbe83de7.svg";